<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  styleClass="email-preview-dialog"
  [style]="{ width: '95vw', height: '90vh' }"
  [contentStyle]="{ padding: '0', height: '100%' }"
  [header]="'Preview: ' + (email?.subject || 'Email')"
  (onHide)="close()"
>
  <div class="email-preview">
    <!-- Tabs: Renderizado vs HTML -->
    <p-tabView [styleClass]="'preview-tabs'">
      <!-- Tab: Vista Renderizada -->
      <p-tabPanel header="Vista Renderizada" leftIcon="fa-solid fa-eye">
        <div class="rendered-view">
          <div class="preview-info mb-2">
            <i class="fa-solid fa-info-circle"></i>
            <span>Vista previa del email tal como lo vería el destinatario</span>
          </div>
          <!-- B-053 · Esto era un [innerHTML] con el saneador DESACTIVADO sobre el cuerpo de un correo
               ya enviado. Ese cuerpo lo compone el backend interpolando datos del cliente SIN escapar
               (`renderTemplate`, en email-channel.service.ts), así que un cliente con un nombre
               preparado dejaba un guion guardado que se ejecutaba en la sesión de quien abriera la
               vista previa, con su token.
               Ahora va en un marco AISLADO: `sandbox` sin `allow-scripts` significa que nada de lo que
               haya ahí dentro puede ejecutarse, ni alcanzar la sesión del panel. El correo deja de
               heredar los estilos del panel, que es justo lo correcto en una vista previa. -->
          <iframe
            class="rendered-content"
            [srcdoc]="getSanitizedHtml()"
            sandbox
            referrerpolicy="no-referrer"
            title="Vista previa del correo"
          ></iframe>
        </div>
      </p-tabPanel>

      <!-- Tab: Código HTML -->
      <p-tabPanel header="Código HTML" leftIcon="fa-solid fa-code">
        <div class="html-view">
          <div class="code-actions mb-2">
            <button
              pButton
              label="Copiar HTML"
              icon="fa-solid fa-copy"
              class="p-button-sm p-button-outlined"
              [disabled]="!hasBodyHtml"
              (click)="copyHtml()"
            ></button>
            <button
              pButton
              label="Descargar HTML"
              icon="fa-solid fa-download"
              class="p-button-sm p-button-outlined p-button-info"
              [disabled]="!hasBodyHtml"
              (click)="downloadHtml()"
            ></button>
          </div>
          <pre class="code-display" *ngIf="hasBodyHtml"><code>{{ htmlContent }}</code></pre>
          <div class="no-content-message" *ngIf="!hasBodyHtml">
            <i class="pi pi-info-circle"></i>
            <p>No hay código HTML disponible para este email.</p>
          </div>
        </div>
      </p-tabPanel>
    </p-tabView>
  </div>

  <ng-template pTemplate="footer">
    <div class="dialog-footer">
      <button pButton label="Cerrar" icon="fa-solid fa-times" class="p-button-secondary" (click)="close()"></button>
    </div>
  </ng-template>

  <!-- Toast para notificaciones -->
  <p-toast></p-toast>
</p-dialog>
